import { Overlay, OverlayConfig, OverlayRef } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import {
  Component,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { LynxModalConstant } from '../../../constants/modal-constant';
import { ModalIconType } from '../../../enums/modal-icon-type';
import { ModalEvent } from '../../../interfaces/modal-event';
import { LynxModalService } from '../../../services/modal.service';

@Component({
    selector: 'lynx-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
    standalone: false
})
export class ModalComponent implements OnInit, OnDestroy {
  @ViewChild('modal', { static: true }) modal: TemplateRef<any>;
  public ModalIconType = ModalIconType;
  public modalEvent: ModalEvent;
  private overlayRef: OverlayRef;
  private subscriptions: Subscription[] = [];

  constructor(
    private overlay: Overlay,
    private viewContainerRef: ViewContainerRef,
    private modalService: LynxModalService
  ) {}

  ngOnInit() {
    const sub = this.modalService.toggle$.subscribe(
      (modalEvent: ModalEvent) => {
        this.resetModal();
        this.updateModal(modalEvent);
      }
    );
    this.subscriptions.push(sub);
    this.initialize();
  }

  ngOnDestroy(): void {
    for (const sub of this.subscriptions) {
      sub.unsubscribe();
    }
  }

  private initialize(): void {
    this.resetModal();

    const strategy = this.overlay
      .position()
      .global()
      .centerHorizontally()
      .centerVertically();

    const config = new OverlayConfig({
      hasBackdrop: true,
      positionStrategy: strategy,
      scrollStrategy: this.overlay.scrollStrategies.block(),
      width: `${LynxModalConstant.width}px`,
    });

    this.overlayRef = this.overlay.create(config);

    const sub = this.overlayRef.backdropClick().subscribe(() => {
      this.overlayRef.detach();
    });
    this.subscriptions.push(sub);
  }

  private resetModal(): void {
    this.modalEvent = <ModalEvent>{};
  }

  updateModal(modalEvent: ModalEvent) {
    this.close();
    this.modalEvent = modalEvent;
    this.overlayRef.attach(
      new TemplatePortal(this.modal, this.viewContainerRef)
    );
  }

  close(): void {
    if (this.overlayRef && this.overlayRef.hasAttached()) {
      this.overlayRef.detach();
    }
  }

  closeWithAction() {
    this.close();
    if (this.modalEvent.button && this.modalEvent.button.action) {
      this.modalEvent.button.action();
    }
  }
}
